import { Link } from 'react-router-dom';

const stats = [
  { value: '24h', label: '全天候更新' },
  { value: '3大', label: '核心新闻频道' },
  { value: '100%', label: '权威来源核实' },
  { value: '0延迟', label: '热点即时推送' },
];

export default function SiteIntro() {
  return (
    <section className="mt-12 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr]">
        <div className="p-6 md:p-10">
          <span className="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-800">
            <i className="ri-shield-check-line" />
            关于爆料网
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-9 text-foreground-950 md:text-3xl">
            第一时间，把重要的新闻爆料讲清楚
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-600">
            爆料网是一个聚焦新闻爆料与事件报道的资讯门户。我们围绕社会热点、娱乐资讯与生活动态三大方向，持续追踪事件的来龙去脉，力求做到信息新鲜、全面、有深度。无论你关注的是城市治理、文娱风向，还是日常生活里的实用提醒，都能在这里快速找到权威、及时的报道。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              了解我们的使命
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              提供新闻线索
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-px bg-background-200">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col justify-center bg-accent-50 p-6">
              <span className="font-heading text-3xl font-black text-primary-700">{stat.value}</span>
              <span className="mt-2 text-sm text-foreground-600">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}